import { Textarea as UITextarea } from "theme-ui";

const Textarea = UITextarea

export default Textarea;
